import React from 'react';

interface ImageProps {
    src: string;
    alt: string;
    show?: boolean;
    className?: string;
    width?: number;
    height: number;
    title?: string;
    loading?: 'eager' | 'lazy' | undefined;
}

const Image: React.FC<ImageProps> = ({ src, alt, show, className, width, height, title, loading = 'lazy' }) => {
    if (show) {
        return (
            <img className={className} src={src} alt={alt}
                width={width} height={height} title={title}
                loading={loading}
            />
        );
    }

    return null;
};

export default Image;
